import { COMMENT_LABELS } from './labels'

export const CommentsLoadError = () => (
  <div className='text-main-foreground-secondary text-body-default'>{COMMENT_LABELS.loadError}</div>
)
